import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";

function LeftNavigationListItem ({ listItemTitle, listItemLink, showCollapsedSideNav, closeCollapsedSideNav }) {
    const location = useLocation();
    const { pathname } = location;
    const isActiveLink = (path) => {
        return pathname === path ? "activeLink" : "";
    };

    const handleOnClick = (e) => {
        closeCollapsedSideNav();
    }

    return (
        <li className="menuItem buttonColor" /*onClick={handleOnClick}*/>
            <Link
                onClick={handleOnClick}
                style={{
                    borderBottom: (showCollapsedSideNav && window.innerWidth < 992) ? "" : "1px solid black"
                }}
                to={listItemLink}
                className={isActiveLink(listItemLink)}>
                {listItemTitle}
            </Link>
        </li>
    );
}

export default LeftNavigationListItem;